import React, { useEffect } from 'react';
import userManager, { signoutRedirect } from '../../services/users/identity/user.service';
import LoadingPage from '../../components/Layout/LoadingPage/LoadingPage.component';
import { revokeUserToken } from '../../services/users/users.service';

export const signoutAsync = async (isTokenNotExpired?: boolean): Promise<void> => {
  if (isTokenNotExpired) {
    revokeUserToken();
    await signoutRedirect();
  } else {
    await userManager.signinRedirect({
      prompt: 'login',
    });
  }
};

export const SignoutOidc: React.FC = () => {
  useEffect(() => {
    signoutAsync(true);
  }, []);

  return <LoadingPage />;
};

export default SignoutOidc;
